var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "close-btn" },
      [
        _c("router-link", { attrs: { to: "/mainStoryView" } }, [
          _c("i", { staticClass: "fa fa-times" })
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "panel-wrapper" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "logic-wrapper inspector-wrap" }, [
          _c("div", { staticClass: "d-inline-flex mb-4" }, [
            _c("h4", { staticClass: "mr-3 mb-0" }, [
              _vm._v("\n            Global Logic List\n          ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "span",
                {
                  staticClass: "cursor-pointer",
                  on: {
                    click: function($event) {
                      return _vm.addNewGlobalLogic()
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "heading-icon",
                    attrs: {
                      src: require("@/assets/addplus_icon.svg"),
                      width: "20"
                    }
                  }),
                  _vm._v("\n        Add new condition\n      ")
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-8 p-0" },
            _vm._l(_vm.global_logic_list, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "mb-3 list-wrapper d-flex align-items-center"
                },
                [
                  _c("div", { staticClass: "col-10" }, [
                    _vm._v(
                      "\n              " + _vm._s(item.title) + "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary btn-sm mr-2",
                        on: {
                          click: function($event) {
                            return _vm.editGlobalLogic(item)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-pencil" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-danger btn-sm",
                        on: {
                          click: function($event) {
                            return _vm.deleteGlobalLogic(item)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-trash" })]
                    )
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc6de9d2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc6de9d2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/global-logic-components/globalLogicList.vue
// module id = null
// module chunks = 